import { Link } from "react-router-dom";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  actionLabel?: string;
  actionHref?: string;
}

export default function SectionHeading({ eyebrow, title, desc, actionLabel, actionHref }: SectionHeadingProps) {
  return (
    <div className="mb-6 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
      <div className="min-w-0">
        {eyebrow && (
          <span className="mb-2 inline-flex items-center gap-2 text-xs font-medium tracking-[0.18em] text-primary-600 uppercase">
            <span className="h-px w-6 bg-primary-500" />
            {eyebrow}
          </span>
        )}
        <h2 className="font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-[28px]">
          {title}
        </h2>
        {desc && <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">{desc}</p>}
      </div>
      {actionLabel && actionHref && (
        <Link
          to={actionHref}
          className="inline-flex shrink-0 items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:bg-primary-50 hover:text-primary-700"
        >
          {actionLabel}
          <i className="ri-arrow-right-line text-base" />
        </Link>
      )}
    </div>
  );
}